import "./modeSelectionStep.styles.scss";

import { ReactComponent as CreateUserGraphic } from "../../../../assets/graphics/CreateUser.svg";
import { ReactComponent as InviteUserGraphic } from "../../../../assets/graphics/InviteUser.svg";

const ModeSelectionStep = ({ mode, setMode }) => {
  return (
    <div className="modeSelectionStepContainer">
      <h2 className="sectionHeading">
        Would you like to Invite a User or Create one?
      </h2>

      <div className="modeSelectionButtonsContainer">
        <button
          className={`modeSelectionButton ${mode === "invite" ? "active" : ""}`}
          onClick={() => setMode("invite")}
        >
          <CreateUserGraphic width={125} />
          <span className="bodyTextLarge">Invite User</span>
        </button>

        <button
          className={`modeSelectionButton ${mode === "create" ? "active" : ""}`}
          onClick={() => setMode("create")}
        >
          <InviteUserGraphic width={125} />

          <span className="bodyTextLarge">Create User</span>
        </button>
      </div>
    </div>
  );
};

export default ModeSelectionStep;
